import { render } from "./NameBox.vue?vue&type=template&id=f101d468&scoped=true"
import script from "./NameBox.vue?vue&type=script&lang=js"
export * from "./NameBox.vue?vue&type=script&lang=js"

import "./NameBox.vue?vue&type=style&index=0&id=f101d468&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-f101d468"

export default script